export {gtmEventTriggers};

function addBrandName(){
  let brandName= sessionStorage.getItem("brandName");
  window.checkoutVariants.forEach(function(variant) {
    variant.brand = brandName;
  });
}
// Parses the basket JSON stored in session for the given fid. Returns {} on failure.
function getBasketData(fid) {
  const basketData = sessionStorage.getItem(fid) || "{}";
  try {
    return JSON.parse(basketData);
  } catch (e) {
    console.log("Invalid basket data");
    return {};
  }
}

//adding source code and campaign code to gtm events
function addSourceCodesToItems(basketData) {
  const sourceCode = basketData?.sourcecode;
  const campaignCode = basketData?.campaigncode;

  window.checkoutVariants.forEach(function (variant) {
    if (sourceCode) {
      variant.sourceCode = sourceCode;
    }
    if (campaignCode) {
      variant.campaignCode = campaignCode;
    }
  });
}

//added discount coupon code and and amount to gtm events.
function addDiscountData(basketData) {
  const lines = Array.isArray(basketData?.lines) ? basketData.lines : [];

 //at item-level
  window.checkoutVariants.forEach(function (variant) {
    const line = lines.find(l => String(l.productvariantid) === String(variant.item_id));
    if (line) {
      if (line.discountcode) {
        variant.coupon = line.discountcode;
      }
      if (line.basediscountnet) {
       
        variant.discount = line.basediscountnet.toFixed(2);
      }
    }
  });

  //at basket-level
  const lineWithDiscount = lines.find(line => line.groupdiscountcode);
  return lineWithDiscount?.groupdiscountcode || null;

}

function addToCartGTM(){
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'add_to_cart',
    category: 'Cart Information',
    action: 'Clicked Button',
    });
}

function removeFromCartGTM(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'remove_from_cart',
      category: 'Cart Information',
      action: 'Clicked Button',
      });
  }

function beginCheckoutGTM(fid, groupDiscountCode){
  try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'begin_checkout',
      category: 'Checkout Process',
      action: 'Clicked Button',
      currency:window.checkoutCurrency,
      items:window.checkoutVariants,
      value:window.checkoutPrice,
      basketId: fid,
      ...(groupDiscountCode && { coupon: groupDiscountCode }),
     
      });

    }catch(e){
      console.log("Variables needed for begin checkout event not present")
    }
  }
  

  function addShippingInfoGTM(fid, groupDiscountCode){
    try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_shipping_info',
      category: 'Shipping Information',
      action: 'Clicked Button',
      currency:window.checkoutCurrency,
      items: window.checkoutVariants,
      value:window.checkoutPrice,
      basketId: fid,
      ...(groupDiscountCode && { coupon: groupDiscountCode }),

      });
    }
    catch(e){
      console.log("Variables needed for add shipping info event not present")
    }

  }

  
  function addBillingInfoGTM(fid, groupDiscountCode){
    try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_billing_info',
      category: 'Billing Information',
      action: 'Clicked Button',
      currency:window.checkoutCurrency,
      items:window.checkoutVariants,
      value:window.checkoutPrice,
      basketId: fid,
      ...(groupDiscountCode && { coupon: groupDiscountCode }),
      });
    }catch(e){
      console.log("Variables needed for billing info event not present")
    }
  }


  function addPaymentInfoGTM(fid, paymentTypeName, groupDiscountCode){
    try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_payment_info',
      category: 'Payment Information',
      action: 'Clicked Button',
      currency:window.checkoutCurrency,
      payment_type: paymentTypeName,
      items:window.checkoutVariants,
      value:window.checkoutPrice,
      basketId: fid,
      ...(groupDiscountCode && { coupon: groupDiscountCode }),
      });
    }
    catch(e){
      console.log("Variables needed for add payment info event not present")
      
    }
  }


  function purchaseGTM(checkoutOrderId, fid, groupDiscountCode){
  
    try{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
         event: 'purchase',
         category: ' Information',
         action: 'Clicked Button',
         currency:window.checkoutCurrency,
         items: window.checkoutVariants,
          transaction_id: checkoutOrderId,
          value: window.checkoutPrice,
          shipping: window.checkoutShippingPrice,
          tax: window.checkoutTax,
          basketId: fid,
          ...(groupDiscountCode && { coupon: groupDiscountCode }),
         
      });
    }catch(e){

       console.log("Variables needed for purchase event not present")
       } 
   }


function gtmEventTriggers(name, orderid, paymentTypeName) {

  const fid = sessionStorage.getItem("fid");
  const basketData = getBasketData(fid);

  // Basket-level group discount code, extarcted once and passed to each GTM event.
  let groupDiscountCode = null;

  if (window.checkoutVariants) {

    addBrandName();
    addSourceCodesToItems(basketData);
    groupDiscountCode = addDiscountData(basketData);

  }


 if(window.checkoutVariants){
      if(name==="begin_checkout"){
       
        beginCheckoutGTM(fid, groupDiscountCode);
        
      }
      if(name==="add_shipping_info"){
       
        addShippingInfoGTM(fid, groupDiscountCode);
      }
      if(name==="add_billing_info"){

        addBillingInfoGTM(fid, groupDiscountCode);
        
      }
      if(name==="add_payment_info"){

        addPaymentInfoGTM(fid, paymentTypeName, groupDiscountCode);

      }
      if(name==="purchase"){

        purchaseGTM(orderid, fid, groupDiscountCode);

    }
  }
}